/**
 * Labstep
 *
 * @module components/Resource/Action/Create/Form
 * @desc Create Action for resource with form
 */

import EntityActionCreateTemplatable from 'labstep-web/components/Entity/Action/Create/Templatable';
import type React from 'react';
import type { IResourceActionCreateFormProps } from './types';

export const ResourceActionCreateForm: React.FC<
  IResourceActionCreateFormProps
> = ({ resourceTemplate, withRedirect, actionComponentProps }) => (
  <EntityActionCreateTemplatable
    entityName="resource"
    templateId={resourceTemplate?.guid}
    actionComponentProps={actionComponentProps}
    withRedirect={withRedirect}
    withName={!resourceTemplate?.custom_identifier_set}
  />
);
